/**
 * Дашбоардын ачаалалтын орлуулагч.
 *
 * Бодит бүтцийг ДАВТАНА: hero → KPI → график → доод хоёр карт.
 * Өмнө нь бүх дэлгэц алга болж дан эргэлдэгч үлддэг байсан тул
 * өгөгдөл ирэх мөчид бүх зүйл үсэрдэг байв.
 */

import { Skeleton, SkeletonRegion, SkeletonStatGrid } from '../skeleton';

export function DashboardSkeleton() {
  return (
    <SkeletonRegion label="Хяналтын самбар ачаалж байна">
      <div className="flex flex-col gap-4">
        {/*
          Hero — өнгө нь тогтмол тул skeleton биш, бодит тууз.
          ⚠️ Өндөр нь `hero-band.tsx`-ийнхтэй ЯГ ТААРАХ ёстой
          (min-h-[168px] sm:min-h-[220px]) — эс тэгвээс өгөгдөл ирэх
          мөчид тууз өндрөө өөрчилж CLS үүснэ.
        */}
        <div className="flex min-h-[168px] flex-col justify-end gap-2 rounded-hero bg-hero px-4 py-5 sm:min-h-[220px] sm:px-10">
          <Skeleton className="h-2.5 w-40 opacity-25" />
          <Skeleton className="h-6 w-64 opacity-40" />
          <Skeleton className="h-2.5 w-32 opacity-25" />
        </div>

        <SkeletonStatGrid count={4} />

        <div className="flex flex-col gap-3.5 surface rounded-card px-4 py-4 sm:px-card">
          <Skeleton className="h-4 w-44" />
          <Skeleton className="h-[176px] w-full rounded-well" />
          <div className="flex flex-col gap-2.5 border-t border-hair pt-3.5">
            {Array.from({ length: 3 }, (_, i) => (
              <Skeleton key={i} className="h-3 w-full" />
            ))}
          </div>
        </div>

        <div className="grid gap-3 xl:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)]">
          <div className="flex flex-col gap-3.5 surface rounded-card px-4 py-4 sm:px-card">
            <Skeleton className="h-4 w-28" />
            {Array.from({ length: 4 }, (_, i) => (
              <Skeleton key={i} className="h-3 w-full" />
            ))}
          </div>
          <div className="flex flex-col gap-3.5 surface rounded-card px-4 py-4 sm:px-card">
            <Skeleton className="h-4 w-48" />
            {Array.from({ length: 5 }, (_, i) => (
              <Skeleton key={i} className="h-3 w-full" />
            ))}
          </div>
        </div>
      </div>
    </SkeletonRegion>
  );
}
